import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, stagger, fadeUp } from "@/lib/motion";
import { SERVICES } from "@/lib/site-data";
import { scrollToSection } from "@/lib/scroll";

const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative mx-auto max-w-[1440px] px-6 py-24 md:px-12 md:py-32"
    >
      <Reveal className="max-w-2xl">
        <span className="eyebrow">What we do</span>
        <h2 className="mt-5 font-heading text-4xl font-semibold leading-[1.05] tracking-tight text-white sm:text-5xl">
          Services built to move your business forward
        </h2>
        <p className="mt-5 text-base leading-relaxed text-white/60 md:text-lg">
          From a brand-new site to a complete redesign, we cover every part of a
          modern web presence — end to end.
        </p>
      </Reveal>

      <motion.div
        variants={stagger(0.07)}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-80px" }}
        className="mt-14 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3"
      >
        {SERVICES.map((s) => {
          const Icon = s.icon;
          return (
            <motion.button
              key={s.title}
              variants={fadeUp}
              onClick={() => scrollToSection("contact")}
              data-testid={`service-card-${s.title.toLowerCase().replace(/[^a-z]+/g, "-").replace(/(^-|-$)/g, "")}`}
              className="group relative overflow-hidden rounded-3xl border border-white/10 bg-ink-soft p-8 text-left transition-all duration-300 hover:-translate-y-1 hover:border-white/25"
            >
              {/* hover glow */}
              <div className="pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full bg-neon-purple/20 opacity-0 blur-3xl transition-opacity duration-500 group-hover:opacity-100" />

              <div className="relative flex items-start justify-between">
                <div className="flex h-14 w-14 items-center justify-center rounded-2xl border border-white/10 bg-gradient-to-br from-white/[0.08] to-transparent text-neon-cyan transition-transform duration-300 group-hover:scale-110">
                  <Icon className="h-6 w-6" />
                </div>
                <ArrowUpRight className="h-5 w-5 text-white/30 transition-all duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 group-hover:text-white" />
              </div>

              <h3 className="relative mt-8 font-heading text-xl font-semibold text-white">
                {s.title}
              </h3>
              <p className="relative mt-3 text-sm leading-relaxed text-white/55">
                {s.text}
              </p>
            </motion.button>
          );
        })}
      </motion.div>
    </section>
  );
};

export default Services;
